import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EField, IExtraData } from "./schema.partnerImportWhise.types";

export const getInitialValues = (extraData: IExtraData): IValues => {
  return {
    [EField.WhiseId]: undefined,
  };
};
